<template>
  <v-app>
    <!--v-app-bar
      <app
      color="#b81a1a;"
      dark
    -->
    <v-card>
      <v-container fluid  >
        <v-layout  align-center justify-center >
          <v-flex xs12>
            <v-card color="white" >
              <v-layout  >
                <v-flex align-self-center xs2>
                  <v-img
                    src="https://www.registromercantilbcn.es/wp-content/uploads/logoR-trans.png"
                    height="70px"
                    contain
                  ></v-img>
                </v-flex>
                <v-flex xs10>
                  <v-card-title primary-title>
                    <div>
                      <div class="headline">Incorporación de la hoja COVID a cuentas previamente presentadas</div>
                      <div class="headline">Incorporació del full COVID a comptes previament presentats</div>
                    </div>
                  </v-card-title>
                </v-flex>
              </v-layout>
              
              </v-card>

               <Form v-if="compatible" />
               <div v-else style="align: center;margin: 20px;text-align: center">
                 <br/>
                 <h2> Navegador Incompatible, por favor intente usar otro navegador o una versión mas reciente </h2>
                 <h2> Navegador Incompatible, si us plau, provi de fer servir un altre navegador o una versió mes nova </h2>
                 <br/>
                </div>
              </v-flex>
             
          </v-layout>
          </v-container>
        </v-card>
      
        
      <!--v-spacer></v-spacer-->
    
      
    

  
      
     
      
      <!--fileUpload/-->
      
      <!--HelloWorld/-->
    
  </v-app>
</template>

<script>
import Form from './components/Form';
//import fileUpload from './components/fileUpload';
export default {
  name: 'App',

  components: {
    Form,
    //fileUpload
  },

  data: () => ({
    compatible: false,
    //
  }),
  mounted(){
    this.compatible = (window.FormData !== undefined );
  }
};
</script>
